import { type FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";

import CheckMark from "nvent-web/assets/svg/check-mark.svg";
import CrossMark from "nvent-web/assets/svg/cross-mark.svg";
import { type Test, type TestType } from "nvent-web/types/Test";

import style from "./TestProgress.module.scss";
import { camelCase } from "text-camel-case";

interface TestProgressItemProps {
  test: Test;
  onClick: (type: TestType) => void;
  hideHeatResistance: boolean;
  showLine: boolean;
}

const TestProgressItem: FunctionComponent<TestProgressItemProps> = ({
  test,
  onClick,
  hideHeatResistance,
  showLine,
}) => (
  <div onClick={() => onClick(test.type)} className={style.info}>
    <h3 className={style.title}>
      <FormattedMessage id={`tests.${camelCase(test.type)}.title`} />
    </h3>
    <div className={style.testDataWrapper}>
      <div className={style.testData}>
        {!hideHeatResistance && (
          <div className={style.heatResistanceRow}>
            <p className={style.label}>
              <FormattedMessage id="form.heatResistance" />
            </p>
            <span className={style.value}>{test.heatResistance}</span>
          </div>
        )}
        <div className={style.heatResistanceRow}>
          <p className={style.label}>
            <FormattedMessage id="form.insulationResistance" />
          </p>
          <span className={style.value}>{test.insulationResistance}</span>
        </div>
      </div>
      <div className={style.checkCircle}>
        {test.completed ? <img src={CheckMark} /> : <img src={CrossMark} />}
        {showLine && <div className={style.line} />}
      </div>
    </div>
  </div>
);

export default TestProgressItem;
